import canUseMse from './canUseMse.js';
export default canUseMse;


// WEBPACK FOOTER //
// ./components/FPlayer-component-utils/index.js